// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAcquireSection4X_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 17.4922C15.0376 17.4922 17.5 15.0298 17.5 11.9922C17.5 8.95462 15.0376 6.49219 12 6.49219C8.96243 6.49219 6.5 8.95462 6.5 11.9922C6.5 15.0298 8.96243 17.4922 12 17.4922ZM12 18.9922C15.866 18.9922 19 15.8582 19 11.9922C19 8.12619 15.866 4.99219 12 4.99219C8.13401 4.99219 5 8.12619 5 11.9922C5 15.8582 8.13401 18.9922 12 18.9922Z" class="svg-bg"/>
  <path d="M0 11.2498H24V12.7498H0V11.2498Z" class="svg-bg"/>
  <path d="M12.75 6.55671e-08L12.75 24H11.25L11.25 0L12.75 6.55671e-08Z" class="svg-bg"/>
  <path d="M4.04505 2.98439L21.0156 19.955L19.955 21.0156L2.98439 4.04505L4.04505 2.98439Z" class="svg-bg"/>
  <path d="M21.0156 4.04505L4.04505 21.0156L2.98439 19.955L19.955 2.98439L21.0156 4.04505Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAcquireSection4X is a generated icon component.
 */
let IconMedAcquireSection4X = IconMedAcquireSection4X_1 = class IconMedAcquireSection4X extends IconBaseElement {
    render() {
        return html `${IconMedAcquireSection4X_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAcquireSection4X.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAcquireSection4X = IconMedAcquireSection4X_1 = __decorate([
    customElement('zui-icon-med-acquire-section-4-x')
], IconMedAcquireSection4X);
export { IconMedAcquireSection4X };
